import {
    Order_Validate as validateApi
} from "./backend"
import { NotificationProgrammatic as Notification } from 'buefy'
import store from '@/store/index'
import i18n from '@/i18n'
const validateOrder = async () => {
    let { data } = await validateApi({

            id: localStorage.getItem('CURRENT_ID'),
            key: localStorage.getItem('TOKEN')
        
    });
    return data;
};

const invalidOrderHandler = (validationResult) => {
    let stringToDisplay = i18n.t('errors.order-errors.order-adjusted');
    if (validationResult.itemQuantityChanged) {
        stringToDisplay += i18n.t('errors.order-errors.quantity-adjusted');
    }
    if (validationResult.itemSoldOut) {
        stringToDisplay += i18n.t('errors.order-errors.article-removed');
    }
    if (validationResult.reductionInvalidated) {
        stringToDisplay += i18n.t('errors.order-errors.code-not-valid');
    }
    stringToDisplay += i18n.t('general.check-order');
    Notification.open({
        duration: 5000,
        message: stringToDisplay,
        position: 'is-bottom-right',
        type: 'is-danger',
        hasIcon: true
    });
    store.dispatch('refreshCart');
}

export default {
    validateOrder,
    invalidOrderHandler
}